module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yx-4310a1143e03c82123c2b55cd92e92be.png";